import React, { useState, useEffect, useContext } from "react";
import { Box } from "@mui/system";
import Sidebar from "./sidebar";
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Avatar,
} from "@mui/material";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/material/styles";
import SaveAsIcon from "@mui/icons-material/SaveAs";

import "../App.css";

import { doc, updateDoc, query, collection, getDocs } from "firebase/firestore";
import { db, storage } from "../firebase.js";
import { uploadBytes, ref, getDownloadURL } from "firebase/storage";
import { DropzoneAreaBase } from "material-ui-dropzone";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
//import FormControl from '@mui/material/FormControl';
import FormLabel from "@mui/material/FormLabel";

import { useNavigate, useLocation } from "react-router-dom";

import DeleteIcon from "@mui/icons-material/Delete";

import DataContext from "../context/context";
import getDropDownData from "./hook/getDropDownData";
import getCorrespondenceTypes from "../utils/correspondenceTypes";
import getRehabLocations from "../utils/rehabLocations";

const steps = [
  "General Information",
  "Housing Journey",
  "Other Agencies",
  "Moses Journey",
  "Addictions & Medication",
  "Rehab Journey",
  "Offending History",
  "Correspondence",
  "Files",
];

let trainingType = [
  "Experiencing Homelessness",
  "Hostel/Shared Accommodation",
  "Sofa Surfing",
  "Living with Friends",
  "Living with Family",
  "Private Rent",
  "Council House",
  "Own House",
];

let rehab = ["Rehab 1", "Rehab 2", "Rehab 3"];
trainingType = trainingType.sort((a, b) => a.localeCompare(b));
// qualificationType = qualificationType.sort((a, b) => a.localeCompare(b));

export default function UpdateProfile() {
  const [rows, setRows] = useState([]);
  const [dropDownData, setdropDownData] = useState();

  let dropdata = useContext(DataContext);

  let arr = [];

  useEffect(() => {
    test();

    async function test() {
      arr = [];
      getData();
    }

    setRows(arr);
    setdropDownData(dropdata);
    if (!dropdata) {
      setdropDownData(getDropDownData());
    }
  }, []);

  async function getData() {
    let arr = [];
    const q = query(collection(db, "staff"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      let obj = doc.data();
      Object.assign(obj, { doc: doc.id });
      console.log(obj);
      arr.push(obj);
    });

    setRows(arr);
  }

  const employee = useLocation().state.employee;

  const [firstName, setfirstName] = useState(employee.firstName);
  const [surName, setsurName] = useState(employee.surName);
  const [nationalInsurance, setNationalInsurance] = useState(
    employee.nationalInsurance
  );
  const [email, setemail] = useState(employee.email);
  const [address1, setaddress1] = useState(employee.address1);
  const [address2, setaddress2] = useState(employee.address2);
  const [contact, setcontact] = useState(employee.contact);
  const [DOB, setDOB] = useState(employee.DOB);
  const [postCode, setpostCode] = useState(employee.postCode);
  const [homeless, sethomeless] = useState(employee.homeless);
  const [town, settown] = useState(employee.town);
  const [nationalIns, setnationalIns] = useState(employee.nationalIns);
  const [nextOfKinName, setnextOfKinName] = useState(employee.nextOfKinName);
  const [nextOfKinNumber, setnextOfKinNumber] = useState(
    employee.nextOfKinNumber
  );
  const [nextOfKineRelationship, setnextOfKineRelationship] = useState(
    employee.nextOfKineRelationship
  );
  const [url, seturl] = useState(employee.files);
  const [profilePic, setProfilePic] = useState(employee.profilePic || "");
  const [gender, setGender] = useState(employee.gender || "");
  const [child, setchild] = useState(employee.child);
  const [childloc, setchildloc] = useState(employee.childloc);

  const [concDate, setconcDate] = useState("");
  const [concType, setconcType] = useState("");
  const [concLog, setconcLog] = useState("");
  const [concComment, setconcComment] = useState("");
  const [concImage, setconcImage] = useState("");
  const [concImageUploading, setconcImageUploading] = useState(false);
  const [conc, setconc] = useState(employee.conc);

  const [startDate, setstartDate] = useState(employee.startDate);
  const [expectedDate, setexpectedDate] = useState(employee.expectedDate);
  const [actualEndDate, setactualEndDate] = useState(employee.actualEndDate);
  const [outcome, setOutcome] = useState(employee.outcome || "");
  const [buddy, setbuddy] = useState(employee.buddy);
  
  // Referral Form state variables
  const [referralForm, setReferralForm] = useState(employee.referralForm || "");
  const [referralOthersDetails, setReferralOthersDetails] = useState(employee.referralOthersDetails || "");

  const [prison, setprison] = useState(employee.prison);
  const [howMany, sethowMany] = useState(employee.howMany);
  const [totlaMonthsServed, settotlaMonthsServed] = useState(
    employee.totlaMonthsServed
  );
  const [probation, setProbation] = useState(employee.probation);
  const [probationOfficer, setProbationOfficer] = useState(
    employee.probationOfficer
  );
  const [sexOffender, setSexOffender] = useState(employee.sexOffender);
  const [numberOfOffences, setNumberOfOffences] = useState(
    employee.numberOfOffences
  );

  const [RehabDrugs, setRehabDrugs] = useState(employee.RehabDrugs);

  // Medical History and Prescribed Medication state variables
  const [medicalHistory, setMedicalHistory] = useState(employee.medicalHistory || "");
  const [prescribedMedication, setPrescribedMedication] = useState(employee.prescribedMedication || "");

  const [LifeStyle, setLifeStyle] = useState(employee.LifeStyle);

  const [Agencies, setAgencies] = useState(employee.Agencies);

  const [statusc, setstatusc] = useState(employee.statusc);

  const a = useLocation().state.activeStep;

  const [activeStep, setActiveStep] = React.useState(a);
  const [completed, setCompleted] = React.useState({});

  let main;

  const pushData = async () => {
    console.log(inputList);
    main = {
      id: Date.now(),
      firstName,
      surName,
      gender,
      nationalInsurance,
      email,
      address1,
      address2,
      contact,
      DOB,
      postCode,
      homeless,
      town,
      nationalIns,
      nextOfKinName,
      nextOfKinNumber,
      nextOfKineRelationship,
      files: url,
      profilePic,
      child,
      childloc,

      statusc,

      conc,

      startDate,
      expectedDate,
      actualEndDate,
      outcome,

      prison,
      howMany,
      totlaMonthsServed,
      probation,
      probationOfficer,
      sexOffender,
      numberOfOffences,
      buddy,

      // Referral Form fields
      referralForm,
      referralOthersDetails,

      house: inputList,
      rehab: inputList1,
      convication: inputList2,
      RehabDrugs,
      Agencies,
      LifeStyle,

      // Medical History and Prescribed Medication fields
      medicalHistory,
      prescribedMedication,
    };
    console.log(main);
    console.log(employee.doc);
    const washingtonRef = doc(db, "employee", employee.doc);
    await updateDoc(washingtonRef, main);
    handleComplete();
  };

  const resetState = () => {
    setfirstName();
    setsurName();
    setGender("");
    setNationalInsurance();
    setemail();
    setaddress1();
    setaddress2();
    setcontact();
    setDOB();
    setpostCode();
    sethomeless();
    settown();
    setnationalIns();
    setnextOfKinName();
    setnextOfKinNumber();
    setnextOfKineRelationship();
    seturl();
    setchild();
    setchildloc();

    setconc([]);
    setconcComment();
    setconcDate();
    setconcLog();
    setconcType();
    setconcImage("");

    setstartDate();
    setexpectedDate();
    setactualEndDate();
    setOutcome("");

    setProbation();
    setProbationOfficer();
    setSexOffender();
    setNumberOfOffences();
    setRehabDrugs();
  };

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
        // find the first step that has been completed
        steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
    resetState();
  };

  const [inputList, setInputList] = React.useState(employee.house);
  const [inputList1, setInputList1] = React.useState(employee.rehab);
  const [inputList2, setInputList2] = React.useState(employee.convication);

  // handle input change
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };
  const handleInputChange1 = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList1];
    list[index][name] = value;
    setInputList1(list);
  };
  const handleInputChange2 = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList2];
    list[index][name] = value;
    setInputList2(list);
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };
  const handleRemoveClick1 = (index) => {
    const list = [...inputList1];
    list.splice(index, 1);
    setInputList1(list);
  };
  const handleRemoveClick2 = (index) => {
    const list = [...inputList2];
    list.splice(index, 1);
    setInputList2(list);
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([...inputList, { training: "", date: "" }]);
  };
  const handleAddClick1 = () => {
    setInputList1([...inputList1, { qualification: "", date: "" }]);
  };
  const handleAddClick2 = () => {
    setInputList2([...inputList2, { type: "", date: "" }]);
  };

  const navigate = useNavigate();

  const handleConcImageUpload = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    setconcImageUploading(true);
    try {
      const path = `caseStudies/${Date.now()}_${file.name}`;
      const storageRef = ref(storage, path);
      await uploadBytes(storageRef, file);
      const u = await getDownloadURL(storageRef);
      setconcImage(u);
    } catch (error) {
      alert("Image upload failed: " + error.message);
    } finally {
      setconcImageUploading(false);
    }
  };

  const handleCompleteSPC = () => {
    let obj = {
      concDate,
      concType,
      concLog,
      concComment,
      concImage: concType === "Case Study" ? concImage : "",
      id: Date.now() * Math.random(),
    };
    setconc((oldArray) => [...(oldArray || []), obj]);

    setconcDate("");
    setconcType("");
    setconcLog("");
    setconcComment("");
    setconcImage("");

    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  //FOR COLOR DROP DOWN

  const [colorDropDown, setcolorDropDown] = useState({});

  function checkColor(status) {
    if (status == "GREEN") {
      setcolorDropDown({ backgroundColor: "green", color: "white" });
    } else if (status == "ORANGE") {
      setcolorDropDown({ backgroundColor: "orange", color: "white" });
    } else if (status == "RED") {
      setcolorDropDown({ backgroundColor: "red", color: "white" });
    } else {
      setcolorDropDown({ color: "black" });
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        marginBottom: "50px",
        height: "100vh",
      }}
    >
      <Sidebar />

      <Button
        variant="contained"
        onClick={() => {
          pushData();
          let a = activeStep;
          navigate("/profile", {
            state: {
              employee: main,
              activeStep: a,
            },
          });
        }}
        style={{
          position: "absolute",
          right: "15px",
          bottom: "20px",
          borderRadius: "50",
          width: "50px",
          height: "50px",
          backgroundColor: "#F21D2F",
        }}
      >
        <SaveAsIcon />
      </Button>

      <Box sx={{ width: "60%" }}>
        {<h3>Name: {employee.firstName + " " + employee.surName}</h3>}
        <Stepper
          activeStep={activeStep}
          nonLinear
          alternativeLabel
          sx={{
            "& .Mui-active": {
              color: "#F21D2F",
            },
          }}
        >
          {steps.map((label, index) => (
            <Step key={label} completed={completed[index]}>
              <StepButton color="inherit" onClick={handleStep(index)}>
                {label}
              </StepButton>
            </Step>
          ))}
        </Stepper>
        <div>
          {allStepsCompleted() ? (
            <React.Fragment>
              <div className="LoginPage2">
                <Typography sx={{ mt: 2, mb: 1 }}>
                  Beneficiary Updated Successfully!!
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button
                    onClick={() => navigate("/home")}
                    style={{ color: "#F21D2F" }}
                  >
                    Home
                  </Button>
                </Box>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {/* ADDING FORM */}

              {activeStep == 0 ? (
                <div className="LoginPage">
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: "100%", mb: 2 }}>
                    <Avatar
                      src={profilePic || undefined}
                      sx={{ width: 80, height: 80, bgcolor: "#F21D2F" }}
                    >
                      {firstName ? firstName[0] : "?"}
                    </Avatar>
                    <Button
                      variant="outlined"
                      component="label"
                      style={{ color: "#F21D2F", borderColor: "#F21D2F" }}
                    >
                      Upload Photo
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={async (e) => {
                          const file = e.target.files[0];
                          if (!file) return;
                          const blob = await fetch(URL.createObjectURL(file)).then((r) => r.blob());
                          const storageRef = ref(storage, `profilePics/${Date.now()}`);
                          await uploadBytes(storageRef, blob);
                          const url = await getDownloadURL(storageRef);
                          setProfilePic(url);
                        }}
                      />
                    </Button>
                    {profilePic && (
                      <Button
                        size="small"
                        style={{ color: "#F21D2F" }}
                        onClick={() => setProfilePic("")}
                      >
                        Remove
                      </Button>
                    )}
                  </Box>
                  <TextField
                    className="addform"
                    id="outlined-basic"
                    label="First Name"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setfirstName(e.target.value)}
                    value={firstName}
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Surname"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setsurName(e.target.value)}
                    value={surName}
                  />
                  <FormControl style={{ width: "45%" }}>
                    <InputLabel id="demo-simple-select-label">
                      Status{" "}
                    </InputLabel>
                    <Select
                      value={statusc}
                      onChange={(e) => {
                        setstatusc(e.target.value);
                        checkColor(e.target.value);
                      }}
                      style={colorDropDown}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Location"
                    >
                      <MenuItem
                        value={"GREEN"}
                        style={{ backgroundColor: "green", color: "white" }}
                      >
                        ㅤ
                      </MenuItem>
                      <MenuItem
                        value={"ORANGE"}
                        style={{ backgroundColor: "Orange", color: "white" }}
                      >
                        ㅤ
                      </MenuItem>
                      <MenuItem
                        value={"RED"}
                        style={{ backgroundColor: "red", color: "white" }}
                      >
                        ㅤ
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    type="date"
                    label="Date of Birth"
                    InputLabelProps={{ shrink: true }}
                    className="addform"
                    style={{ width: "45%" }}
                    id="outlined-basic"
                    variant="outlined"
                    onChange={(e) => setDOB(e.target.value)}
                    value={DOB}
                  />
                  <FormControl style={{ width: "45%" }}>
                    <InputLabel id="gender-select-label">Gender</InputLabel>
                    <Select
                      value={gender}
                      onChange={(e) => setGender(e.target.value)}
                      labelId="gender-select-label"
                      id="gender-select"
                      label="Gender"
                    >
                      <MenuItem value={"Male"}>Male</MenuItem>
                      <MenuItem value={"Female"}>Female</MenuItem>
                      <MenuItem value={"Other Gender"}>Other Gender</MenuItem>
                    </Select>
                  </FormControl>
                  {/* <FormControl style={{ display: "flex", flexDirection: "row", gap: "30px" }}>
                      <FormLabel id="demo-radio-buttons-group-label" style={{ alignSelf: "center" }}>Experiencing Homelessness</FormLabel>
                      <RadioGroup
                        onChange={(e) => sethomeless(e.target.value)} value={homeless}
                        row
                        aria-labelledby="demo-radio-buttons-group-label"

                        name="radio-buttons-group"
                      >
                        <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                        <FormControlLabel value="no" control={<Radio />} label="NO" />
                      </RadioGroup>
                    </FormControl> */}
                  <TextField
                    type="number"
                    className="addform"
                    id="outlined-basic"
                    label="Contact"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setcontact(e.target.value)}
                    value={contact}
                  />
                  <TextField
                    type="email"
                    className="addform"
                    id="outlined-basic"
                    label="Email"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setemail(e.target.value)}
                    value={email}
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="National Insurance"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setNationalInsurance(e.target.value)}
                    value={nationalInsurance}
                  />

                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Address 1"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setaddress1(e.target.value)}
                    value={address1}
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Address 2"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setaddress2(e.target.value)}
                    value={address2}
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Town/County"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => settown(e.target.value)}
                    value={town}
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Post Code"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setpostCode(e.target.value)}
                    value={postCode}
                  />
                  <TextField
                    type="number"
                    className="addform"
                    id="outlined-basic"
                    label="Qty of Children"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setchild(e.target.value)}
                    value={child}
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Children’s Location"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setchildloc(e.target.value)}
                    value={childloc}
                  />
                  {/* <TextField type="text" className='addform' id="outlined-basic" label="Post Code" variant="outlined" style={{ width: "45%", visibility: "hidden" }} /> */}

                  {/* JOE CONVERT EMERGENCY TO THIS */}

                  <TextField
                    className="addform"
                    id="outlined-basic"
                    label="Next of Kin Name"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setnextOfKinName(e.target.value)}
                    value={nextOfKinName}
                  />
                  <TextField
                    type="number"
                    className="addform"
                    id="outlined-basic"
                    label="Next of Kin Number"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setnextOfKinNumber(e.target.value)}
                    value={nextOfKinNumber}
                  />
                  {/* <TextField type="text" className='addform' id="outlined-basic" label="Next of Kin Relationship" variant="outlined" style={{ width: "45%" }} onChange={(e) => setnextOfKineRelationship(e.target.value)} value={nextOfKineRelationship} /> */}
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Next of kin Relationship"
                    variant="outlined"
                    style={{ width: "45%", visibility: "hidden" }}
                  />

                  <div style={{ flexBasis: "100%", height: 0 }} />
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className="addform"
                    variant="outlined"
                    style={{
                      marginTop: "30px",
                      width: "48%",
                      color: "#F21D2F",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                  </Button>
                  <Button
                    onClick={handleComplete}
                    className="addform"
                    variant="contained"
                    style={{
                      width: "48%",
                      height: "50px",
                      marginTop: "30px",
                      backgroundColor: "#F21D2F",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                  </Button>

                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Next of kin Relationship"
                    variant="outlined"
                    style={{
                      width: "45%",
                      visibility: "hidden",
                      paddingBottom: "30px",
                    }}
                  />
                </div>
              ) : activeStep == 1 ? (
                <>
                  <div className="LoginPageALT">
                    <FormControl style={{ width: "45%" }}>
                      <InputLabel id="demo-simple-select-label">
                        Referral From{" "}
                      </InputLabel>
                      <Select
                        value={referralForm}
                        onChange={(e) => setReferralForm(e.target.value)}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Referral From"
                      >
                        {dropDownData && dropDownData.HousingJourneyReferralFrom ? dropDownData.HousingJourneyReferralFrom.map((val) => (
                          <MenuItem value={val}>{val}</MenuItem>
                        )) : null}
                      </Select>
                    </FormControl>
                    
                    {referralForm === "Others" && (
                      <TextField
                        className="addform"
                        id="outlined-basic"
                        label="Please specify"
                        variant="outlined"
                        style={{ width: "45%" }}
                        value={referralOthersDetails}
                        onChange={(e) => setReferralOthersDetails(e.target.value)}
                      />
                    )}
                  </div>
                  <hr className="solid" />
                  <div className="LoginPageALT">
                    {inputList.map((x, i) => {
                      return (
                        <div style={{ width: "100%", display: "flex", gap: "10px" }}>
                          <FormControl style={{ width: "30%" }}>
                            <InputLabel id="demo-simple-select-label">
                              Status
                            </InputLabel>
                            <Select
                              value={inputList[i].status}
                              name="status"
                              onChange={(e) => handleInputChange(e, i)}
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Status"
                            >
                              {dropDownData
                                ? dropDownData.housingStatusType.map((val) => (
                                  <MenuItem value={val}>{val}</MenuItem>
                                ))
                                : null}
                            </Select>
                          </FormControl>

                          <TextField
                            onChange={(e) => handleInputChange(e, i)}
                            value={inputList[i].location}
                            name="location"
                            type="text"
                            label="Location"
                            className="addform"
                            style={{ width: "30%" }}
                            id="outlined-basic"
                            variant="outlined"
                          />

                          <TextField
                            onChange={(e) => handleInputChange(e, i)}
                            value={inputList[i].date}
                            name="date"
                            type="date"
                            label="Date"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "30%" }}
                            id="outlined-basic"
                            variant="outlined"
                          />
                          {inputList.length !== 1 && (
                            <Button
                              onClick={() => handleRemoveClick(i)}
                              className="addform"
                              variant="contained"
                              style={{
                                width: "5%",
                                backgroundColor: "#FF6A74",
                                marginLeft: "10px",
                                height: "50px",
                                color: "white ",
                                borderColor: "red",
                              }}
                            >
                              <DeleteIcon sx={{ color: "white" }} />
                            </Button>
                          )}

                          <div className="btn-box">
                            {inputList.length - 1 === i && (
                              <Button
                                onClick={handleAddClick}
                                className="addform"
                                variant="outlined"
                                style={{
                                  width: "100%",
                                  height: "50px",
                                  // marginTop: "30px",
                                  color: "#F21D2F",
                                  borderColor: "#F21D2F",
                                }}
                              >
                                + Add New
                              </Button>
                            )}
                          </div>
                        </div>
                      );
                    })}

                    <div style={{ flexBasis: "100%", height: 0 }} />
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className="addform"
                      variant="outlined"
                      style={{
                        width: "48%",
                        color: "#F21D2F",
                        borderColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                    </Button>
                    <Button
                      onClick={handleComplete}
                      className="addform"
                      variant="contained"
                      style={{
                        width: "48%",
                        backgroundColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                    </Button>
                  </div>
                </>
              ) : activeStep == 2 ? (
                <>
                  <div style={{ marginTop: "10px" }}>
                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      className="addform"
                      id="outlined-basic"
                      size="small"
                      label={Agencies.AdultCare.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.AdultCare.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.AdultCare.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            AdultCare: {
                              ...Agencies.AdultCare,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      className="addform"
                      size="small"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.AdultCare.Contactname}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          AdultCare: {
                            ...Agencies.AdultCare,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      className="addform"
                      id="outlined-basic"
                      size="small"
                      label={Agencies.MentalHealth.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.MentalHealth.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.MentalHealth.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            MentalHealth: {
                              ...Agencies.MentalHealth,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.MentalHealth.Contactname}
                      size="small"
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          MentalHealth: {
                            ...Agencies.MentalHealth,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      className="addform"
                      id="outlined-basic"
                      size="small"
                      label={Agencies.CGL.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.CGL.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.CGL.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            CGL: {
                              ...Agencies.CGL,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      className="addform"
                      size="small"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.CGL.Contactname}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          CGL: {
                            ...Agencies.CGL,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      className="addform"
                      id="outlined-basic"
                      size="small"
                      label={Agencies.Housing.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.Housing.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.Housing.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            Housing: {
                              ...Agencies.Housing,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.Housing.Contactname}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          Housing: {
                            ...Agencies.Housing,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={Agencies.SocialServices.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.SocialServices.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.SocialServices.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            SocialServices: {
                              ...Agencies.SocialServices,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.SocialServices.Contactname}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          SocialServices: {
                            ...Agencies.SocialServices,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={Agencies.Probation.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.Probation.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.Probation.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            Probation: {
                              ...Agencies.Probation,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.Probation.Contactname}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          Probation: {
                            ...Agencies.Probation,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={Agencies.FoodBank.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.FoodBank.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.FoodBank.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            FoodBank: {
                              ...Agencies.FoodBank,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.FoodBank.Contactname}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          FoodBank: {
                            ...Agencies.FoodBank,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />
                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={Agencies.GP.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.GP.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.GP.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            GP: {
                              ...Agencies.GP,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.GP.Contactname}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          GP: {
                            ...Agencies.GP,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={Agencies.Blank1.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.Blank1.Name}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          Blank1: {
                            ...Agencies.Blank1,
                            Name: e.target.value,
                          },
                        })
                      }
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.Blank1.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            Blank1: {
                              ...Agencies.Blank1,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.Blank1.Contactname}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          Blank1: {
                            ...Agencies.Blank1,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={Agencies.Blank2.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.Blank2.Name}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          Blank2: {
                            ...Agencies.Blank2,
                            Name: e.target.value,
                          },
                        })
                      }
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.Blank2.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            Blank2: {
                              ...Agencies.Blank2,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.Blank2.Contactname}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          Blank2: {
                            ...Agencies.Blank2,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />
                  </div>

                  <div className="LoginPage">
                    <div style={{ flexBasis: "100%", height: 0 }} />
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className="addform"
                      variant="outlined"
                      style={{
                        width: "48%",
                        color: "#F21D2F",
                        borderColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                    </Button>
                    <Button
                      onClick={handleComplete}
                      className="addform"
                      variant="contained"
                      style={{
                        width: "48%",
                        backgroundColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                    </Button>
                  </div>
                </>
              ) : activeStep == 3 ? (
                <>
                  <div
                    style={{ display: "flex", marginTop: "50px", gap: "10px" }}
                  >
                    <TextField
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      className="addform"
                      id="outlined-basic"
                      label="Registered Date"
                      variant="outlined"
                      style={{ width: "45%", flex: 2 }}
                      onChange={(e) => setstartDate(e.target.value)}
                      value={startDate}
                    />
                    <TextField
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      className="addform"
                      id="outlined-basic"
                      label="Actual End Date"
                      variant="outlined"
                      style={{ width: "45%", flex: 2 }}
                      onChange={(e) => setactualEndDate(e.target.value)}
                      value={actualEndDate}
                    />
                    <FormControl style={{ width: "45%", flex: 2 }}>
                      <InputLabel id="outcome-select-label">Outcome</InputLabel>
                      <Select
                        value={outcome}
                        onChange={(e) => setOutcome(e.target.value)}
                        labelId="outcome-select-label"
                        id="outcome-select"
                        label="Outcome"
                      >
                        <MenuItem value={""}></MenuItem>
                        <MenuItem value={"Rehab Successful"}>
                          Rehab Successful
                        </MenuItem>
                        <MenuItem value={"Deceased"}>Deceased</MenuItem>
                        <MenuItem value={"Barred"}>Barred</MenuItem>
                        <MenuItem value={"Unknown"}>Unknown</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  <div style={{ marginTop: "20px" }} id="LIFESTYLE">
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Alcohol Misuse/Addiction
                      </InputLabel>
                      <Select
                        value={LifeStyle.Alchohol}
                        onChange={(e) =>
                          setLifeStyle({
                            ...LifeStyle,
                            Alchohol: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Alcohol Misuse/Addiction"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Offending Behaviour
                      </InputLabel>
                      <Select
                        value={LifeStyle.Behaviour}
                        onChange={(e) =>
                          setLifeStyle({
                            ...LifeStyle,
                            Behaviour: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Depression
                      </InputLabel>
                      <Select
                        value={LifeStyle.Depression}
                        onChange={(e) =>
                          setLifeStyle({
                            ...LifeStyle,
                            Depression: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Drug Missuse/Addiction
                      </InputLabel>
                      <Select
                        value={LifeStyle.Drug}
                        onChange={(e) =>
                          setLifeStyle({ ...LifeStyle, Drug: e.target.value })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}>Empty</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Eating Disorder
                      </InputLabel>
                      <Select
                        value={LifeStyle.Eating}
                        onChange={(e) =>
                          setLifeStyle({ ...LifeStyle, Eating: e.target.value })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Mental Health
                      </InputLabel>
                      <Select
                        value={LifeStyle.Mental}
                        onChange={(e) =>
                          setLifeStyle({ ...LifeStyle, Mental: e.target.value })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Debt Problems
                      </InputLabel>
                      <Select
                        value={LifeStyle.Debt}
                        onChange={(e) =>
                          setLifeStyle({ ...LifeStyle, Debt: e.target.value })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Self Harm
                      </InputLabel>
                      <Select
                        value={LifeStyle.Self}
                        onChange={(e) =>
                          setLifeStyle({ ...LifeStyle, Self: e.target.value })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Physical Health
                      </InputLabel>
                      <Select
                        value={LifeStyle.Physical}
                        onChange={(e) =>
                          setLifeStyle({
                            ...LifeStyle,
                            Physical: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Unemployment
                      </InputLabel>
                      <Select
                        value={LifeStyle.Unemployment}
                        onChange={(e) =>
                          setLifeStyle({
                            ...LifeStyle,
                            Unemployment: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Low Self Esteem/Confidence
                      </InputLabel>
                      <Select
                        value={LifeStyle.Confidence}
                        onChange={(e) =>
                          setLifeStyle({
                            ...LifeStyle,
                            Confidence: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Violent Behaviour
                      </InputLabel>
                      <Select
                        value={LifeStyle.Violent}
                        onChange={(e) =>
                          setLifeStyle({
                            ...LifeStyle,
                            Violent: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  <div className="LoginPage">
                    <div style={{ flexBasis: "100%", height: 0 }} />
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className="addform"
                      variant="outlined"
                      style={{
                        width: "48%",
                        color: "#F21D2F",
                        borderColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                    </Button>
                    <Button
                      onClick={handleComplete}
                      className="addform"
                      variant="contained"
                      style={{
                        width: "48%",
                        backgroundColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                    </Button>
                  </div>
                </>
              ) : activeStep == 4 ? (
                <>
                  <div style={{ marginTop: "30px" }}>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Alcohol
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Alchohol}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Alchohol: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Amphetamines
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Amphetamines}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Amphetamines: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Cannabis
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Cannabis}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Cannabis: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Cocaine
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Cocaine}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Cocaine: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Crack
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Crack}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Crack: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Ecstasy
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Ecstasy}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Ecstasy: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Heroin
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Heroine}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Heroine: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Ketamine
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Ketamine}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Ketamine: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Pregabline
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Pregabline}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Pregabline: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Smoker
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Cigrates}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Cigrates: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Spice
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Spice}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Spice: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Vaping
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Vaping}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Vaping: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Zopiclone
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Zopiclone}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Zopiclone: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Other
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Other}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Other: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        width: "32%",
                        margin: "5px",
                        visibility: "hidden",
                      }}
                    >
                      <InputLabel id="demo-simple-select-label">
                        Ecstasy
                      </InputLabel>
                      <Select
                        // value={inputList1[i].location}
                        // name="location"
                        // onChange={e => handleInputChange1(e, i)}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="LoginPage">
                    <TextField
                      className="addform"
                      id="outlined-basic"
                      label="Medical History"
                      variant="outlined"
                      style={{ width: "48%", marginRight: "1%" }}
                      multiline
                      rows={6}
                      onChange={(e) => setMedicalHistory(e.target.value)}
                      value={medicalHistory}
                    />
                    <TextField
                      className="addform"
                      id="outlined-basic"
                      label="Prescribed Medication"
                      variant="outlined"
                      style={{ width: "48%", marginLeft: "1%" }}
                      multiline
                      rows={6}
                      onChange={(e) => setPrescribedMedication(e.target.value)}
                      value={prescribedMedication}
                    />
                    <div style={{ flexBasis: "100%", height: 0 }} />
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className="addform"
                      variant="outlined"
                      style={{
                        width: "48%",
                        color: "#1c3261",
                        borderColor: "#1c3261",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                    </Button>
                    <Button
                      onClick={handleComplete}
                      className="addform"
                      variant="contained"
                      style={{
                        width: "48%",
                        backgroundColor: "#1c3261",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                    </Button>
                  </div>
                </>
              ) : activeStep == 5 ? (
                <>
                  <div className="LoginPage">
                    {inputList1.map((x, i) => {
                      return (
                        <div style={{ width: "100%" }}>
                          <FormControl style={{ width: "18%" }}>
                            <InputLabel id="demo-simple-select-label">
                              Status
                            </InputLabel>
                            <Select
                              value={inputList1[i].status}
                              name="status"
                              onChange={(e) => handleInputChange1(e, i)}
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Location"
                            >
                              {dropDownData
                                ? dropDownData.RehabJourneyStatus.map(
                                  (val) => (
                                    <MenuItem value={val}>{val}</MenuItem>
                                  )
                                )
                                : null}
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{ width: "12%", marginLeft: "10px" }}
                          >
                            <InputLabel id="demo-simple-select-label">
                              Location
                            </InputLabel>
                            <Select
                              value={inputList1[i].location}
                              name="location"
                              onChange={(e) => handleInputChange1(e, i)}
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Location"
                            >
                              {dropDownData
                                ? getRehabLocations(dropDownData).map((val) => (
                                  <MenuItem value={val}>{val}</MenuItem>
                                ))
                                : null}
                            </Select>
                          </FormControl>

                          <TextField
                            onChange={(e) => handleInputChange1(e, i)}
                            value={inputList1[i].startDate}
                            name="startDate"
                            type="date"
                            label="Start Date"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "18%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                          />
                          <TextField
                            onChange={(e) => handleInputChange1(e, i)}
                            value={inputList1[i].endDate}
                            name="endDate"
                            type="date"
                            label="End Date"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "18%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                          />
                          <TextField
                            onChange={(e) => handleInputChange1(e, i)}
                            value={inputList1[i].value}
                            name="value"
                            type="number"
                            label="Expense £"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "10%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                          />

                          <TextField
                            onChange={(e) => handleInputChange1(e, i)}
                            value={inputList1[i].comment}
                            name="comment"
                            type="text"
                            label="Expense Comments"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "18%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                          />
                          {inputList1.length !== 1 && (
                            <Button
                              onClick={() => handleRemoveClick1(i)}
                              className="addform"
                              variant="contained"
                              style={{
                                width: "5%",
                                backgroundColor: "#FF6A74",
                                marginLeft: "10px",
                                height: "50px",
                                color: "white ",
                                borderColor: "red",
                              }}
                            >
                              <DeleteIcon sx={{ color: "white" }} />
                            </Button>
                          )}

                          <div className="btn-box">
                            {inputList1.length - 1 === i && (
                              <Button
                                onClick={handleAddClick1}
                                className="addform"
                                variant="outlined"
                                style={{
                                  width: "100%",
                                  height: "50px",
                                  marginTop: "30px",
                                  color: "#1c3261",
                                  borderColor: "#1c3261",
                                }}
                              >
                                + Add New
                              </Button>
                            )}
                          </div>
                        </div>
                      );
                    })}

                    <div style={{ flexBasis: "100%", height: 0 }} />
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className="addform"
                      variant="outlined"
                      style={{
                        width: "48%",
                        color: "#1c3261",
                        borderColor: "#1c3261",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                    </Button>
                    <Button
                      onClick={handleComplete}
                      className="addform"
                      variant="contained"
                      style={{
                        width: "48%",
                        backgroundColor: "#1c3261",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                    </Button>
                  </div>
                </>
              ) : activeStep == 7 ? (
                <div className="LoginPage">
                  <TextField
                    type="date"
                    label="Date"
                    InputLabelProps={{ shrink: true }}
                    className="addform"
                    style={{ width: "45%" }}
                    id="outlined-basic"
                    variant="outlined"
                    onChange={(e) => setconcDate(e.target.value)}
                    value={concDate}
                  />
                  <FormControl style={{ width: "45%" }}>
                    <InputLabel id="demo-simple-select-label">Type</InputLabel>
                    <Select
                      onChange={(e) => setconcType(e.target.value)}
                      value={concType}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Type"
                    >
                      {getCorrespondenceTypes(dropDownData).map((val) => (
                        <MenuItem value={val}>{val}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {/* <TextField type="text" label="Logged By" InputLabelProps={{ shrink: true, }} className='addform' style={{ width: "100%" }} id="outlined-basic" variant="outlined" onChange={(e) => setconcLog(e.target.value)} value={concLog} /> */}
                  <FormControl style={{ width: "100%" }}>
                    <InputLabel id="demo-simple-select-label">
                      Logged By{" "}
                    </InputLabel>
                    <Select
                      value={concLog}
                      onChange={(e) => setconcLog(e.target.value)}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Location"
                    >
                      {rows.map((v) => {
                        return (
                          <MenuItem value={v.firstName + " " + v.surName}>
                            {v.firstName + " " + v.surName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <TextField
                    onChange={(e) => setconcComment(e.target.value)}
                    value={concComment}
                    className="addform"
                    style={{ width: "100%" }}
                    // id={ `tt_description_text outlined-multiline-static`}
                    label="Add a comment "
                    multiline
                    rows={5}
                  // onBlur={ (f)=>(this.textOnBlur({id:answeringPainSpot.spotId, value:f.target.value, doc_name:answeringPainSpot.doc_name})) }
                  />

                  {concType === "Case Study" && (
                    <Box style={{ width: "100%", marginTop: "10px" }}>
                      <Button
                        variant="outlined"
                        component="label"
                        style={{ color: "#F21D2F", borderColor: "#F21D2F" }}
                      >
                        {concImageUploading
                          ? "Uploading..."
                          : concImage
                            ? "Change Case Study Image"
                            : "Add Case Study Image"}
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={handleConcImageUpload}
                        />
                      </Button>
                      {concImage && (
                        <Box
                          component="img"
                          src={concImage}
                          alt="Case study"
                          style={{
                            display: "block",
                            marginTop: "10px",
                            maxWidth: "220px",
                            maxHeight: "220px",
                            borderRadius: "8px",
                            objectFit: "cover",
                          }}
                        />
                      )}
                    </Box>
                  )}

                  <div style={{ flexBasis: "100%", height: 0 }} />
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className="addform"
                    variant="outlined"
                    style={{
                      width: "48%",
                      color: "#F21D2F",
                      borderColor: "#F21D2F",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                  </Button>
                  <Button
                    onClick={handleCompleteSPC}
                    className="addform"
                    variant="contained"
                    style={{
                      width: "48%",
                      backgroundColor: "#F21D2F",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                  </Button>
                </div>
              ) : activeStep == 8 ? (
                <div className="LoginPage">
                  <ul>
                    {(url || []).map((item, index) => {
                      return (
                        <li key={index}>
                          {item && item.name ? item.name : item}
                        </li>
                      );
                    })}
                  </ul>

                  <DropzoneAreaBase
                    filesLimit={3}
                    maxFileSize={500000000000000}
                    showPreviews={false}
                    onDrop={async (accept) => {
                      const added = [];
                      for (let i = 0; i < accept.length; i++) {
                        const file = accept[i];
                        const path = `${Date.now()}_${i}_${file.name}`;
                        const blob = await fetch(
                          URL.createObjectURL(file)
                        ).then((r) => r.blob());
                        const storageRef = ref(storage, `files/${path}`);

                        await uploadBytes(storageRef, blob);
                        const u = await getDownloadURL(storageRef);
                        added.push({ path, name: file.name, url: u });
                      }
                      seturl((oldArray) => [...(oldArray || []), ...added]);
                    }}
                  />

                  <div style={{ flexBasis: "100%", height: 0 }} />
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className="addform"
                    variant="outlined"
                    style={{
                      width: "48%",
                      color: "#F21D2F",
                      borderColor: "#F21D2F",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                  </Button>
                  <Button
                    onClick={handleCompleteSPC}
                    className="addform"
                    variant="contained"
                    style={{
                      width: "48%",
                      backgroundColor: "#F21D2F",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                  </Button>
                </div>
              ) : (
                <>
                  <div className="LoginPageALT">
                    <FormControl style={{ width: "45%" }}>
                      <InputLabel id="demo-simple-select-label">
                        Prison Leaver{" "}
                      </InputLabel>
                      <Select
                        value={prison}
                        onChange={(e) => setprison(e.target.value)}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Prison Leaver"
                      >
                        <MenuItem value={"yes"}>Yes</MenuItem>
                        <MenuItem value={"no"}>No</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="number"
                      className="addform"
                      id="outlined-basic"
                      label="How many times"
                      variant="outlined"
                      style={{ width: "45%" }}
                      onChange={(e) => sethowMany(e.target.value)}
                      value={howMany}
                    />

                    <TextField
                      type="number"
                      className="addform"
                      id="outlined-basic"
                      label="Total Months Served"
                      variant="outlined"
                      style={{ width: "45%" }}
                      onChange={(e) => settotlaMonthsServed(e.target.value)}
                      value={totlaMonthsServed}
                    />

                    <FormControl style={{ width: "45%" }}>
                      <InputLabel id="demo-simple-select-label">
                        Probation{" "}
                      </InputLabel>
                      <Select
                        value={probation}
                        onChange={(e) => setProbation(e.target.value)}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"yes"}>Yes</MenuItem>
                        <MenuItem value={"no"}>No</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      className="addform"
                      id="outlined-basic"
                      label="Probation Officer"
                      variant="outlined"
                      style={{ width: "45%" }}
                      onChange={(e) => setProbationOfficer(e.target.value)}
                      value={probationOfficer}
                    />

                    {/* <FormControl style={{ width: "45%" }}>
                              <InputLabel id="demo-simple-select-label">Sex Offender </InputLabel>
                              <Select
                                value={sexOffender}
                                onChange={(e) => setSexOffender(e.target.value)}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Location"
                              >
                                <MenuItem value={"yes"}>Yes</MenuItem>
                                <MenuItem value={"no"}>No</MenuItem>
                              </Select>
                            </FormControl> */}

                    <TextField
                      type="number"
                      className="addform"
                      id="outlined-basic"
                      label="Number of Offences"
                      variant="outlined"
                      style={{ width: "45%" }}
                      onChange={(e) => setNumberOfOffences(e.target.value)}
                      value={numberOfOffences}
                    />

                    <TextField
                      type="text"
                      className="addform"
                      id="outlined-basic"
                      label="Next of Kin Relationship"
                      variant="outlined"
                      style={{ width: "45%", visibility: "hidden" }}
                      onChange={(e) =>
                        setnextOfKineRelationship(e.target.value)
                      }
                      value={nextOfKineRelationship}
                    />
                  </div>
                  <hr className="solid" />
                  <div className="LoginPageALT">
                    {inputList2.map((x, i) => {
                      return (
                        <div style={{ width: "100%" }}>
                          <FormControl style={{ width: "28%" }}>
                            <InputLabel id="demo-simple-select-label">
                              Conviction Type
                            </InputLabel>
                            <Select
                              value={inputList2[i].type}
                              name="type"
                              onChange={(e) => handleInputChange2(e, i)}
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Location"
                            >
                              {dropDownData
                                ? dropDownData.OffendingHistoryConvictionType.map(
                                  (val) => (
                                    <MenuItem value={val}>{val}</MenuItem>
                                  )
                                )
                                : null}
                            </Select>
                          </FormControl>

                          <TextField
                            onChange={(e) => handleInputChange2(e, i)}
                            value={inputList2[i].details}
                            name="details"
                            type="text"
                            label="Details"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "28%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                          />
                          <TextField
                            onChange={(e) => handleInputChange2(e, i)}
                            value={inputList2[i].date}
                            name="date"
                            type="date"
                            label="Date of Conviction"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "28%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                          />
                          {inputList2.length !== 1 && (
                            <Button
                              onClick={() => handleRemoveClick2(i)}
                              className="addform"
                              variant="contained"
                              style={{
                                width: "5%",
                                backgroundColor: "#FF6A74",
                                marginLeft: "10px",
                                height: "50px",
                                color: "white ",
                                borderColor: "red",
                              }}
                            >
                              <DeleteIcon sx={{ color: "white" }} />
                            </Button>
                          )}

                          <div className="btn-box">
                            {inputList2.length - 1 === i && (
                              <Button
                                onClick={handleAddClick2}
                                className="addform"
                                variant="outlined"
                                style={{
                                  width: "100%",
                                  height: "50px",
                                  marginTop: "30px",
                                  color: "#F21D2F",
                                  borderColor: "#F21D2F",
                                }}
                              >
                                + Add New
                              </Button>
                            )}
                          </div>
                        </div>
                      );
                    })}

                    <div style={{ flexBasis: "100%", height: 0 }} />
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className="addform"
                      variant="outlined"
                      style={{
                        width: "48%",
                        color: "#F21D2F",
                        borderColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                    </Button>
                    <Button
                      onClick={handleComplete}
                      className="addform"
                      variant="contained"
                      style={{
                        width: "48%",
                        backgroundColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {"Next"}
                    </Button>
                  </div>
                </>
              )}

              <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                {/* <Button
                    color="inherit"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                  >
                    Back
                  </Button> */}
                <Box sx={{ flex: "1 1 auto" }} />
                {/* <Button onClick={handleNext} sx={{ mr: 1 }}>
                    Next
                  </Button>
                  {activeStep !== steps.length &&
                    (completed[activeStep] ? (
                      <Typography variant="caption" sx={{ display: 'inline-block' }}>
                        Step {activeStep + 1} already completed
                      </Typography>
                    ) : (
                      <Button onClick={handleComplete}>
                        {completedSteps() === totalSteps() - 1
                          ? 'Finish'
                          : 'Complete Step'}
                      </Button>
                    ))} */}
              </Box>
            </React.Fragment>
          )}
        </div>
      </Box>
    </Box>
  );
}
